/**
 * Resolve a URL base da API em runtime.
 *
 * - Em produção (Vercel): usa REACT_APP_BACKEND_URL definido no ambiente.
 * - Em desenvolvimento local: usa o mesmo hostname que o browser está acessando,
 *   na porta 8000 — funciona tanto de localhost quanto de outros dispositivos
 *   na rede local (ex: http://192.168.18.88:3000 → http://192.168.18.88:8000).
 */
const getApiBase = () => {
  // Produção: variável definida explicitamente
  if (process.env.REACT_APP_BACKEND_URL) {
    return `${process.env.REACT_APP_BACKEND_URL}/api`;
  }

  // Desenvolvimento: mesma origem, porta do backend
  const host = window.location.hostname;
  return `http://${host}:8000/api`;
};

export const API = getApiBase();
